export class Time {
  static readonly TEN_MINUTES = 600;
  static readonly ONE_HOUR = 3_600;
  static readonly FOUR_HOURS = 14_400;
  static readonly TEN_HOURS = 36_000;
  static readonly FIVE_DAYS = 432_000;
  static readonly UNLIMITED = 0;
}
